'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentProductOverviewComponent = exports.rentProductOverviewComponent = {
    template: require('./rent-product-overview.html'),
    bindings: {
        rentalProductsCategories: '<',
        seller: '<'
    },
    controllerAs: 'vm',
    controller: ["rentalProductsService", "$stateParams", function controller(rentalProductsService, $stateParams) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.rentalProductsOverview = null;

        function init() {
            loadProducts();
            vm.activeCategory = vm.rentalProductsCategories.find(function (cat) {
                return cat.id === $stateParams.categoryId.toString();
            });
        }

        function loadProducts() {
            vm.rentalProductsOverview = rentalProductsService.init();
            rentalProductsService.getRentalProducts($stateParams.sellerId, $stateParams.categoryId, vm.rentalProductsOverview).then(function (model) {
                vm.rentalProductsOverview = model;
            });
        }

        //but in const
        // vm.banners = [
        //     {
        //         'media': {
        //             'type': 'IMAGE',
        //             'path': 'TGZ\\images\\64e64e25-0f32-401c-bd0c-348db1d57e55.jpeg',
        //             'thumbnailPath': 'TGZ\\images\\64e64e25-0f32-401c-bd0c-348db1d57e55.jpeg',
        //             'description': 'Mobiliteit zonder zorgen',
        //             'priority': null
        //         },
        //         'title': '',
        //         'content': null,
        //         'link': null,
        //         'priority': 1,
        //         'textAlignment': 0,
        //         'backgroundColor': null,
        //         'darkTextColor': false,
        //         'name': '',
        //         'id': null
        //     }
        // ];

        //put in const
        // vm.heroSliderSettings = { 
        //     autoplay: true,
        //     autoplaySpeed: 6000,
        //     dots: true,
        //     draggable: false,
        //     arrows: true,
        //     slidesToShow: 1, 
        //     slidesToScroll: 1,
        //     infinite: true,
        //     responsive: [ 
        //         {
        //             breakpoint: 576,
        //             settings: {
        //                 dots: true, 
        //                 arrows: false
        //             }
        //         }
        //     ]
        // };
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/rent-product-overview.js
// module id = 1029
// module chunks = 0